import { BroadcastChannelGroup } from '../enums/broadcast-channel-group'
import { BroadcastChannelVisibility } from '../enums/broadcast-channel-visibility'

export class BroadcastChannel {
  constructor(
    private readonly group: BroadcastChannelGroup,
    public readonly visibility: BroadcastChannelVisibility,
    private readonly params: { key: string; value: string }[] = []
  ) {}

  getRoute() {
    let route = `${this.group}`
    this.params.forEach(({ key, value }) => {
      route = route.replace(`{${key}}`, value)
    })
    return route
  }
}
